module.exports = __webpack_public_path__ + "4da63968448ff2c3c1c60c01d98b020f.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/news5.jpg
// module id = 201
// module chunks = 0